import '../assets/libs/grid.min.css';
import '../scss/style.scss';
import '../js/main';
import '../js/custom-dropdown';
import '../js/custom-popup';
import '../js/product-quantity';
import '../js/tabs';
import '../js/mobile-menu';
import '../js/mobile-catalog';

const jquery = require("jquery");
const $ = require("jquery");
const jQuery = require("jquery");
window.jQuery = $;
const fancybox = require("@fancyapps/fancybox");
const zoom = require('jquery-zoom/jquery.zoom.min');